<template>
  <div class="addressEdit">
    <van-form @submit="onSubmit">
      <div class="title">修改收货信息</div>
      <div class="content">
        <van-field
          label-class="lablelName"
          name="ReceivingMan"
          v-model="AddressInfo.ReceivingMan"
          label="收货人"
          placeholder="请输入收货人姓名"
          class="input-bo"
        />
        <van-field
          label-class="lablelName"
          name="Phone"
          v-model="AddressInfo.Phone"
          label="手机号"
          placeholder="请输入手机号码"
          class="input-bo"
        />
        <van-row type="flex" align="center" :gutter="20">
          <van-col class="relative">
            <van-field
              label-class="lablelName"
              name="Province"
              v-model="AddressInfo.Province"
              label="所在地区"
              placeholder="省"
              class="select-box input-bo"
              readonly
              @click="Province = !Province"
            />
            <ul v-if="Province">
              <li
                v-for="(item,i) in ProvinceOption"
                :key="i"
                class="c222 f14"
                @click.stop="handleSelect(item,1)"
                :class="{'act':item.Province == AddressInfo.Province}"
              >{{item.Province}}</li>
            </ul>
          </van-col>
          <van-col class="relative">
            <van-field
              label-class="lablelName"
              name="City"
              v-model="AddressInfo.City"
              label
              placeholder="市"
              class="select-box input-bo"
              readonly
              @click="City = !City"
            />
            <ul v-if="City">
              <li
                v-for="(item,i) in CityOption"
                :key="i"
                class="c222 f14"
                @click.stop="handleSelect(item,2)"
                :class="{'act':item.City == AddressInfo.City}"
              >{{item.City}}</li>
            </ul>
          </van-col>
          <van-col class="relative">
            <van-field
              label-class="lablelName"
              name="County"
              v-model="AddressInfo.County"
              label
              placeholder="区"
              class="select-box input-bo"
              readonly
              @click="County = !County"
            />
            <ul v-if="County">
              <li
                v-for="(item,i) in CountyOption"
                :key="i"
                class="c222 f14"
                @click.stop="handleSelect(item,3)"
                :class="{'act':item.County == AddressInfo.County}"
              >{{item.County}}</li>
            </ul>
          </van-col>
        </van-row>

        <van-field
          label-class="lablelName"
          name="AddressName"
          v-model="AddressInfo.AddressName"
          class="input-bo detail"
          input-width="400"
          label="详细地址"
          placeholder="请输入详细地址"
        />
      </div>
      <div class="btn">
        <van-button class="cancel f16" @click="cancel" type="default">取消</van-button>
        <van-button class="ok f16" native-type="submit" type="info">确定</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { BaseMixin } from "../../mixins/BaseMixin";
export default {
  name: "AddressEdit",
  mixins: [BaseMixin],
  props: ["AddressInfo"],
  data() {
    return {
      Province: false,
      City: false,
      County: false,
      ProvinceOption: [],
      CityOption: [],
      CountyOption: []
    };
  },
  mounted() {
    this.getArea();
    this.getArea(1, "");
  },
  methods: {
    handleSelect(item, l) {
      if (l == 1) {
        this.Province = false;
        this.getArea(2, item.Province);
        this.AddressInfo.Province = item.Province;
        this.AddressInfo.City = "";
        return;
      }
      if (l == 2) {
        this.City = false;
        this.getArea(3, item.City);
        this.AddressInfo.City = item.City;
        this.AddressInfo.County = "";
        return;
      }
      if (l == 3) {
        this.County = false;
        this.AddressInfo.County = item.County;
        return;
      }
    },
    // 获取区域
    async getArea(level, KeyWord) {
      const _this = this;
      _this.$hys.openLoading();
      let res = await _this.getAction("/api_basedata/Areas/List", {
        level: level,
        KeyWord: KeyWord
      });
      _this.$hys.clearLoading();
      if (!res.IsSuccess) {
        _this.$toast({ position: "bottom", message: res.Msg });
        return;
      }
      if (res.Data && res.Data.length) {
        if (level == 1) {
          _this.ProvinceOption = res.Data;
          return;
        }
        if (level == 2) {
          _this.CityOption = res.Data;
          return;
        }
        if (level == 3) {
          _this.CountyOption = res.Data;
          return;
        }
      }
    },
    onSubmit() {
      this.$emit("EditClose", true);
    },
    cancel() {
      this.$emit("EditClose", false);
    }
  }
};
</script>
<style lang="less" scoped>
.addressEdit {
  width: 755px;
  height: 540px;
  background-color: white;
  margin: 0;

  .title {
    height: 70px;
    line-height: 110px;
    font-size: 20px;
    // background-color: blue;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
  }

  .content {
    height: 270px;
    margin: 40px 100px;
    text-align: left;

    /deep/.lablelName {
      position: relative;
      top: 13px;
    }

    .input-bo {
      /deep/.van-field__control {
        width: 200px;
        height: 50px;
        border-radius: 2px;
        border: 1px solid rgba(229, 229, 229, 1);
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        box-sizing: border-box;
        padding: 15px;
        font-size: 18px;
      }
    }
    .detail {
      /deep/.van-field__control {
        width: 463px;
      }
    }

    /deep/.van-field__label {
      font-size: 18px;
      font-weight: 400;
    }

    /deep/.van-cell {
      padding: 10px 0px;
    }

    /deep/.van-field__control:hover {
      border: 1px solid rgba(15, 110, 233, 1);
    }
    .select-box {
      /deep/.van-field__control {
        width: 140px;
        padding-right: 30px;
        cursor: pointer;
      }
      /deep/.van-field__body {
        position: relative;
        &::after {
          position: absolute;
          top: 50%;
          margin-top: -5px;
          border: 3px solid;
          border-color: transparent transparent #777777 #777777;
          right: 15px;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          opacity: 0.8;
          content: "";
        }
      }
    }
    ul {
      width: 140px;
      position: absolute;
      right: 0;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 16px 0px rgba(226, 226, 226, 1);
      padding: 0 20px;
      z-index: 1;
      max-height: 200px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #e8e8e8;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #f5f5f5;
      }
      > li {
        padding: 15px 0;
        border-bottom: 1px solid #e8e8e8;
        text-align: left;
        cursor: pointer;
        &:last-child {
          border-bottom: 0;
        }
        &:hover {
          color: rgba(15, 110, 234, 1);
        }
      }
      .act {
        color: rgba(15, 110, 234, 1);
      }
    }
  }

  .btn {
    margin: 60px;
    // background-color: burlywood;

    .cancel {
      width: 140px;
      height: 50px;
      background: rgba(226, 226, 226, 1);
      border-radius: 2px;
    }

    .ok {
      width: 140px;
      height: 50px;
      margin-left: 40px;
      background: rgba(15, 110, 234, 1);
      border-radius: 2px;
    }
  }
}
</style>